<div class="flex flex-column gap-3">
  <div class="flex gap-4">
    <p-select
      [options]="installations()"
      optionLabel="name"
      optionValue="id"
      placeholder="Buscar instalación..."
      class="w-full md:w-25rem"
      [filter]="true"
      filterBy="name"
      [ngModel]="selectedInstallationId()"
      (ngModelChange)="onInstallationChange($event)">
      <ng-template let-installation #item>
        <div class="flex align-items-center gap-2">
          @if (installationLogoUrl(installation); as logoUrl) {
          <img
            [src]="logoUrl"
            alt=""
            width="40"
            height="40"
            style="object-fit: contain"
            (error)="onInstallationLogoError(installation.id)" />
          } @else {
          <i class="ph-duotone ph-buildings text-xl"></i>
          }
          <span>{{ installation.name }}</span>
        </div>
      </ng-template>
    </p-select>
    <div class="flex justify-content-start">
      <ls-button-icon-atom
        label="Añadir usuario"
        icon="pi pi-plus"
        severity="primary"
        [disabled]="!selectedInstallationId()"
        (onClick)="addUserPopover.toggle($event)"></ls-button-icon-atom>

      <p-popover
        #addUserPopover
        appendTo="body"
        styleClass="add-user-popover-panel">
        <div class="flex flex-column gap-3 add-user-popover">
          <p-multiSelect
            [options]="unassignedUsers()"
            optionLabel="displayName"
            optionValue="id"
            placeholder="Selecciona usuarios"
            [filter]="true"
            filterBy="nombre,apellidos,email"
            display="chip"
            [showToggleAll]="false"
            appendTo="body"
            [(ngModel)]="usersToAdd">
            <ng-template let-user #item>
              <span
                >{{ user.nombre }} {{ user.apellidos }} — {{ user.email }}</span
              >
            </ng-template>
          </p-multiSelect>
          <ls-button-icon-atom
            [label]="addUsersLabel"
            icon="pi pi-check"
            severity="primary"
            [disabled]="usersToAdd.length === 0"
            (onClick)="addUsers(addUserPopover)"></ls-button-icon-atom>
        </div>
      </p-popover>
    </div>
  </div>
  @if (!selectedInstallationId()) {
  <p class="text-color-secondary">
    Selecciona una instalación para ver sus usuarios y permisos.
  </p>
  } @else if (loadingUsers()) {
  <ls-progress-spinner-atom></ls-progress-spinner-atom>
  } @else { @if (!hasAssignedUsers()) {
  <p class="text-color-secondary">
    Esta instalación no tiene usuarios con acceso todavía.
  </p>
  } @else {
  <ls-input-atom
    placeholder="Buscar usuario..."
    [showIcon]="true"
    class="w-full md:w-25rem"
    [ngModel]="userSearchTerm()"
    (ngModelChange)="userSearchTerm.set($event)"></ls-input-atom>
  @if (!hasResults()) {
  <p class="text-color-secondary">
    No se han encontrado usuarios que coincidan con la búsqueda.
  </p>
  } @else {
  <div class="flex flex-column gap-4">
    @if (admins().length > 0) {
    <section class="flex flex-column gap-2">
      <small class="section-label">Admin</small>
      @for (user of admins(); track user.userId) {
      <ng-container
        *ngTemplateOutlet="
          userRow;
          context: { $implicit: user }
        "></ng-container>
      }
    </section>
    } @if (regularUsers().length > 0) {
    <section class="flex flex-column gap-2">
      <small class="section-label">Usuarios</small>
      @for (user of regularUsers(); track user.userId) {
      <ng-container
        *ngTemplateOutlet="
          userRow;
          context: { $implicit: user }
        "></ng-container>
      }
    </section>
    }
  </div>
  } } }
</div>

<ng-template #userRow let-user>
  <div class="flex align-items-center justify-content-between user-row">
    <div class="flex align-items-center gap-2">
      <ls-avatar-atom
        [image]="user.image"
        [label]="initials(user)"></ls-avatar-atom>
      <div class="flex flex-column">
        <span class="font-semibold"
          >{{ user.nombre }} {{ user.apellidos }}</span
        >
        <small class="text-color-secondary">{{ user.email }}</small>
      </div>
    </div>

    <div class="flex gap-3 align-items-center">
      <p-tag [value]="getRoleLabel(user.role)"></p-tag>
      <div class="flex gap-1">
        <i
          class="ph-duotone ph-envelope-simple text-xl cursor-pointer"
          [class.text-color-secondary]="!user.notifyEmail"
          [class.text-primary]="user.notifyEmail"
          (click)="toggleNotifyEmail(user)"></i>
        <i
          class="ph-duotone ph-chat-text text-xl cursor-pointer"
          [class.text-color-secondary]="!user.notifySms"
          [class.text-primary]="user.notifySms"
          (click)="toggleNotifySms(user)"></i>
      </div>
      <div class="flex gap-1 action-icons">
        <i severity="primary" (click)="editUser(user.userId)">
          <i class="ph-duotone ph-note-pencil text-xl"></i>
        </i>
        <i severity="danger" (click)="revokeAccess(user)">
          <i class="ph-duotone ph-trash text-xl"></i>
        </i>
      </div>
    </div>
  </div>
</ng-template>
